module.exports = __webpack_public_path__ + "img/201905241616321.21ab6b97.png";